import { parse, stringify } from 'query-string';
import useStewardshipFilter from './useStewardshipFilter';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { user_tags_educator } from '../../../utils/query-helpers';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const stewardshipFilter = useStewardshipFilter();

  return useConnect('organization.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfJobs',
            relation: 'jobs',
            $where: {
              ...user_tags_educator(),
              // siteId: {
              //   $null: true
              // },
              $or: stewardshipFilter
            }
          }
        ],
        $where: {
          // ...tags_educator(),
          // siteId: {
          //   $null: true
          // },
          // $or: stewardshipFilter,
          ...extra
        },
        $having: {
          numberOfJobs: {
            $gt: 0
          }
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
